<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.5" cx="80" cy="80" r="80" fill="#352478" />
    <circle opacity="0.5" cx="80.0002" cy="79.9997" r="56.0544" fill="#352478" />
    <circle cx="79.9998" cy="80.0002" r="37.551" fill="#352478" />
    <path
        d="M62.1387 83.2401L70.9579 89.9711L85.1191 73.7868L82.3189 71.3398L70.4484 84.9061L64.3923 80.2836L62.1387 83.2401ZM98.135 73.7868L95.3347 71.3398L83.4921 84.8745L82.092 83.7551L79.7677 86.6595L83.9458 90.0027L98.135 73.7868Z"
        fill="#EEEBF9" />
</svg>
